import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { DadosOcorrenciaSafraEdi, Ocorrencia, TTitulosPossiveisSafraEdi } from "../../../../../../types/api/financeiro/detalhar-integracao-bancaria";
import moment from "moment";
import { useState } from "react";
import DialogIndicarTitulo from "./DialogIndicarTitulo.tsx/DialogIndicarTitulo";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import DataSemResultados from "../../../../../../components/DataSemResultados";
import { ModalDetalheTituloProvider } from "../../../MIContasReceber/ModalDetalheTituloContext";
import { darken } from '@mui/material/styles';
import { enqueueSnackbar } from "notistack";
import CopyIconInput from "../../../../../../components/BasicComponents/CopyIconInput";

export default function TableDadosSafraEdi({
    tipo,
    rows,
    somenteVisualizacao,
    handleAlterarLinha
}: TTableDadosSafraEdiProps) {

    const [openModalTitulo, setOpenModalTitulo] = useState<IOpenModal | null>(null)

    return (
        <Box width='100%'>
            <TableContainer sx={{ maxHeight: "74vh" }}>
                <Table stickyHeader aria-label="sticky table" size="small"
                    sx={{ '& td': { fontSize: "0.75rem" } }}
                >
                    <TableHead>
                        <TableRow>
                            <TableCell ><b>Transação</b></TableCell>
                            <TableCell ><b>Pagamento</b></TableCell>
                            <TableCell ><b>Nsu</b></TableCell>
                            <TableCell ><b>EC</b></TableCell>
                            <TableCell ><b>Tipo</b></TableCell>
                            <TableCell align="right" ><b>Bruto venda</b></TableCell>
                            <TableCell align="right" ><b>Taxa venda</b></TableCell>
                            <TableCell align="right" ><b>Líquido venda</b></TableCell>
                            <TableCell align="right" ><b>Qtd. Parcelas</b></TableCell>
                            <TableCell align="right" ><b>Parcela atual</b></TableCell>
                            <TableCell ><b>Resposta</b></TableCell>
                            <TableCell ><b>Status</b></TableCell>
                            <TableCell ><b>Título</b></TableCell>
                        </TableRow>
                    </TableHead>

                    {
                        rows.length > 0 &&
                        <TableBody>
                            {rows.map((row) => {
                                const tituloResposta = row.resumo_dados.resposta
                                const status = row.status
                                let permitirEditar = true;
                                const resumo = row.resumo_dados as DadosOcorrenciaSafraEdi

                                let colorBg = ''
                                if (status === "Aguardando finalização") colorBg = "#e5f6fd"
                                if (status === "Conflito encontrado") colorBg = "#fff9e6"
                                if (status === "Finalizado") {
                                    permitirEditar = false;
                                    colorBg = "#e5fde5";
                                }

                                let colorTitulo = 'info'
                                if (
                                    tituloResposta === "Múltiplos títulos encontrados pelo NSU" ||
                                    tituloResposta === "Múltiplos títulos encontrados pela data de emissão e valor" ||
                                    tituloResposta === "Títulos encontrados com divergências"
                                ) colorTitulo = "#ef7918"

                                if (
                                    tituloResposta === "Título encontrado pelo NSU" ||
                                    tituloResposta === "Título encontrado pela data de emissão e valor" ||
                                    tituloResposta === "Título selecionado manualmente"
                                ) {
                                    colorTitulo = "primary"
                                }

                                if (tituloResposta === "Título não encontrado") colorTitulo = "error"

                                return (
                                    <TableRow
                                        key={row.id}
                                        sx={{
                                            '&:last-child td, &:last-child th': { border: 0 },
                                            backgroundColor: colorBg,
                                            cursor: (somenteVisualizacao || status === "Finalizado" || !permitirEditar) ? 'default' : 'pointer',
                                            '&:hover': {
                                                backgroundColor: darken(colorBg, 0.1),
                                            },
                                        }}
                                        onClick={() => {
                                            if (!somenteVisualizacao && status !== "Finalizado" && permitirEditar) {
                                                setOpenModalTitulo({
                                                    idRow: row.id,
                                                    titulo: resumo.titulo,
                                                    titulos_possiveis: resumo.titulos_possiveis,
                                                    observacao: resumo.observacao || null
                                                })
                                            }
                                        }}
                                    >
                                        <TableCell>
                                            {moment(resumo.data_transacao).format("DD/MM/YYYY")}
                                            {resumo.data_transacao && (
                                                <CopyIconInput value={moment(resumo.data_transacao).format("DD/MM/YYYY")} size="small" messageValue="Transação" />
                                            )}
                                        </TableCell>
                                        <TableCell>{moment(resumo.data_pagamento).format("DD/MM/YYYY")}</TableCell>
                                        <TableCell>
                                            {resumo.nsu ?? '-'}
                                            {resumo.nsu && (
                                                <CopyIconInput value={resumo.nsu} size="small" messageValue="NSU" />
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {resumo.estabelecimento}
                                            {resumo.estabelecimento && (
                                                <CopyIconInput value={`${resumo.estabelecimento}`} size="small" messageValue="Estabelecimento" />
                                            )}
                                        </TableCell>
                                        <TableCell>{resumo.modalidade}</TableCell>
                                        <TableCell align="right">
                                            {formatarValorMonetario((resumo.valor_bruto_parcela ?? 0) === 0 ? resumo.valor_bruto_venda ?? 0 : resumo.valor_bruto_parcela ?? 0)}
                                            {
                                                <CopyIconInput value={`${(resumo.valor_bruto_parcela ?? 0) === 0 ? resumo.valor_bruto_venda ?? 0 : resumo.valor_bruto_parcela ?? 0}`} size="small" messageValue="Valor Bruto" />
                                            }
                                            </TableCell>
                                        <TableCell align="right">{formatarValorMonetario((resumo.valor_desconto_parcela ?? 0) === 0 ? resumo.valor_taxa_venda ?? 0 : resumo.valor_desconto_parcela ?? 0)}</TableCell>
                                        <TableCell align="right">{formatarValorMonetario((resumo.valor_liquido_parcela ?? 0) === 0 ? resumo.valor_liquido_venda ?? 0 : resumo.valor_liquido_parcela ?? 0)}</TableCell>
                                        <TableCell align="right">{resumo.qtd_parcelas}</TableCell>
                                        <TableCell align="right">{resumo.parcela_atual}</TableCell>
                                        <TableCell >
                                            <Typography variant="subtitle2" color={colorTitulo}>
                                                {resumo.resposta}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>{row.status}</TableCell>
                                        <TableCell onClick={() => {
                                            if (!somenteVisualizacao && status !== "Finalizado" && permitirEditar) {
                                                setOpenModalTitulo({
                                                    idRow: row.id,
                                                    titulo: resumo.titulo,
                                                    titulos_possiveis: resumo.titulos_possiveis,
                                                    observacao: resumo.observacao || null
                                                })
                                            }
                                        }}>
                                            <Typography variant="subtitle2" color={colorTitulo} >
                                                {resumo.titulo ? 
                                                    (typeof resumo.titulo === 'string' && 
                                                     (resumo.titulo.startsWith('[') || resumo.titulo.includes('"')) ? 
                                                        resumo.titulo.replace(/[\[\]"\\]/g, '') : 
                                                        resumo.titulo) 
                                                    : "-"}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    }
                    {
                        rows.length === 0 &&
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={17} align="center">
                                    <DataSemResultados size="medium" texto="Nenhum resultado encontrado" />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    }
                </Table>
            </TableContainer>

            {
                openModalTitulo &&
                <ModalDetalheTituloProvider>
                    <DialogIndicarTitulo
                        {...{ tipo }}
                        open={Boolean(openModalTitulo.idRow)}
                        titulo={openModalTitulo.titulo}
                        opcoes={openModalTitulo.titulos_possiveis}
                        observacao={openModalTitulo.observacao}
                        handleClose={() => setOpenModalTitulo(null)}
                        handleSubmit={(titulo: string, observacao?: string) => handleAlterarLinha(openModalTitulo.idRow, titulo, observacao)}
                        handleLimpar={() => handleAlterarLinha(openModalTitulo.idRow)}
                    />
                </ModalDetalheTituloProvider>
            }
        </Box>
    )
}

interface TTableDadosSafraEdiProps {
    tipo: string;
    rows: Ocorrencia[],
    somenteVisualizacao: boolean,
    handleAlterarLinha: (id: number, titulo?: string, observacao?: string) => void
}

interface IOpenModal {
    idRow: number;
    titulo: string | null,
    titulos_possiveis: TTitulosPossiveisSafraEdi[]
    observacao: string | null;
}

